module.exports = __webpack_public_path__ + "img/location-exclamation.6fa968a5.svg";